import { render } from "./SocialMedia.vue?vue&type=template&id=2a266e96&scoped=true"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"

import "./SocialMedia.vue?vue&type=style&index=0&id=2a266e96&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2a266e96"

export default script